import { useEffect, useRef, useState } from "react";
function useAnimatedValue(targetValue, duration, animate) {
    const actualTargetValue = targetValue ?? 0;
    const [animatedValue, setAnimatedValue] = useState(actualTargetValue);
    const animatedValueRef = useRef(actualTargetValue);
    useEffect(()=>{
        animatedValueRef.current = animatedValue;
    }, [
        animatedValue
    ]);
    useEffect(()=>{
        if (!animate) return void setAnimatedValue(actualTargetValue);
        const currentValue = animatedValueRef.current;
        const valueRange = actualTargetValue - currentValue;
        const startTime = performance.now();
        if (duration <= 0 || 0 === valueRange) return void setAnimatedValue(actualTargetValue);
        let animationFrame;
        const animateValue = (currentTime)=>{
            const elapsedTime = currentTime - startTime;
            if (elapsedTime >= duration) setAnimatedValue(actualTargetValue);
            else {
                const progress = elapsedTime / duration;
                const easeProgress = 1 - (1 - progress) * (1 - progress);
                const nextValue = currentValue + valueRange * easeProgress;
                setAnimatedValue(nextValue);
                animationFrame = requestAnimationFrame(animateValue);
            }
        };
        animationFrame = requestAnimationFrame(animateValue);
        return ()=>{
            cancelAnimationFrame(animationFrame);
        };
    }, [
        actualTargetValue,
        duration,
        animate
    ]);
    return Math.round(animatedValue);
}
export { useAnimatedValue };
